export const onDialogConfirmConfirmModel = () => ({
  widget: 'models',
  type: 'onDialogConfirmConfirmModel',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogConfirmConfirmModel.js